import { useEffect } from 'react';

const SendIdentity = ({ Email }) => {
  console.log('Info: SendIdentity component called');
  
  useEffect(() => {
    window._uxa = window._uxa || [];
    // Add 5-second delay before sending identity
    // TODO: Remove this delay and replace with a more reliable mechanism
    setTimeout(() => {
      window._uxa.push(["identify", Email]);
    }, 5000);
  }, [Email]);

  return null;
};

export default SendIdentity; 